import { Dispatch } from 'redux';

import { Alert } from "@mui/material";

import Input from './Input';

import { highlightErrors, onSubmitSuccess, onSubmitError } from '../../actions/login';
import { validateForm } from '../../utils/formData';
import { Reducer } from '../../reducers';
import { LoginReducer } from '../../reducers/login';
import { ReduxComponentInterface } from 'edocatbase/Global';
import Button from '../../../global/Components/Button';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


interface FormProps extends LoginReducer, ReduxComponentInterface {}

class Form extends React.PureComponent<FormProps> {
  private readonly form: any;

  constructor(props: FormProps) {
    super(props);

    this.form = React.createRef();

    // @ts-ignore
    window.onSubmitSuccess = this.onSubmitSuccess;
    // @ts-ignore
    window.onSubmitFailure = this.onSubmitFailure;
  }

  onSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const { actions, form } = this.props;
    const errors = validateForm(form);

    if (!errors.username && !errors.password) {
      actions.highlightErrors(errors);
      this.form.current.submit();

      // yes, it is deprecated, we know. But IE 11...
      try {
        // @ts-ignore
        window.external.AutoCompleteSaveForm(this.form.current.cloneNode(true));
      } catch (e) {
        // do nothing
      }
    } else {
      actions.highlightErrors(errors);
    }
  };

  onSubmitSuccess = () => {
    const { actions } = this.props;
    actions.onSubmitSuccess();
  };

  onSubmitFailure = () => {
    const { actions } = this.props;
    actions.onSubmitError();
  };

  render() {
    const { error, errors, processing, redirecting } = this.props;

    return (
      <form
        action={`${window.Edocat.texts.appContext}/page/dologin`}
        className="Login-Form"
        method="POST"
        onSubmit={this.onSubmit}
        ref={this.form}
        target="iframe"
      >
        {error && <Alert severity="error">{window.Edocat.texts['login.failed']}</Alert>}
        <div className="Form-Input">
          <Input autoComplete="username" autoFocus name="username" label={window.Edocat.texts['label.username']} />
          <Input autoComplete="current-password" name="password" label={window.Edocat.texts['label.password']} type="password" />
          <input
            type="text"
            className="hidden"
            name="success"
            value={`${window.Edocat.texts.appContext}/page/success`}
          />
          <input
            type="text"
            className="hidden"
            name="failure"
            value={`${window.Edocat.texts.appContext}/page/failure`}
          />
        </div>
        <div className="Form-Row Button-Row">
          <Button
            primary
            label={window.Edocat.texts['label.login']}
            disabled={processing || errors.username || errors.password || redirecting}
            type="submit"
            sx={{ width: '100%' }}
            id="signInBtn"
						loading={redirecting}
          />
        </div>
        {/*{redirecting && <Modal />}*/}
        <div className="Copy-Info">
          <p>{window.Edocat.texts['edocat.footer.softwaredocat']}</p>
          <p>
            {window.Edocat.texts['edocat.footer.edocatlink']}{' '}
            <a href="http://www.edocat.cz" target="edocat">
              www.edocat.cz
            </a>{' '}
            {window.Edocat.texts['edocat.footer.onliolink']}{' '}
            <a href="http://www.onlio.com" target="onlio">
              www.onlio.com
            </a>
            .
          </p>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  form: state.login.form,
  errors: state.login.errors,
  error: state.login.error,
  processing: state.login.processing,
  redirecting: state.login.redirecting,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ highlightErrors, onSubmitSuccess, onSubmitError }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
